import React from 'react';
import { Card, Button, Typography, Space } from 'antd';
import { WarningCircleIcon, ArrowsClockwiseIcon } from '@phosphor-icons/react';

const { Title, Text } = Typography;

class MobileErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // Log error to service (optional)
        console.error('Mobile Error Boundary caught:', error, errorInfo);
    }

    handleReload = () => {
        this.setState({ hasError: false, error: null });
        window.location.reload();
    };

    handleGoBack = () => {
        this.setState({ hasError: false, error: null });
        window.history.back();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '100vh',
                    padding: '20px',
                    background: 'linear-gradient(180deg, #f5f7fa 0%, #ffffff 100%)'
                }}>
                    <Card
                        style={{
                            maxWidth: 400,
                            width: '100%',
                            borderRadius: 16,
                            boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                            textAlign: 'center'
                        }}
                    >
                        <Space direction="vertical" size="large" style={{ width: '100%' }}>
                            <div style={{
                                width: 64,
                                height: 64,
                                margin: '0 auto',
                                borderRadius: 32,
                                background: 'linear-gradient(135deg, #ff4d4f 0%, #ff7875 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <WarningCircleIcon weight="fill" size={32} style={{ color: 'white' }} />
                            </div>

                            <div>
                                <Title level={4} style={{ marginBottom: 8 }}>
                                    Bir Hata Oluştu
                                </Title>
                                <Text type="secondary" style={{ fontSize: 14 }}>
                                    Sayfa yüklenirken bir sorun meydana geldi. Lütfen sayfayı yenileyin veya geri dönün.
                                </Text>
                            </div>

                            <Space direction="vertical" size={12} style={{ width: '100%' }}>
                                <Button
                                    type="primary"
                                    block
                                    size="large"
                                    icon={<ArrowsClockwiseIcon weight="bold" />}
                                    onClick={this.handleReload}
                                    style={{
                                        borderRadius: 12,
                                        height: 48,
                                        fontWeight: 600
                                    }}
                                >
                                    Sayfayı Yenile
                                </Button>
                                <Button
                                    block
                                    size="large"
                                    onClick={this.handleGoBack}
                                    style={{
                                        borderRadius: 12,
                                        height: 48
                                    }}
                                >
                                    Geri Dön
                                </Button>
                            </Space>

                            {process.env.NODE_ENV === 'development' && this.state.error && (
                                <details style={{ textAlign: 'left', marginTop: 16 }}>
                                    <summary style={{ cursor: 'pointer', color: '#ff4d4f' }}>
                                        Hata Detayları (Dev)
                                    </summary>
                                    <pre style={{
                                        fontSize: 10,
                                        background: '#f5f5f5',
                                        padding: 12,
                                        borderRadius: 8,
                                        overflow: 'auto',
                                        marginTop: 8
                                    }}>
                                        {this.state.error.toString()}
                                    </pre>
                                </details>
                            )}
                        </Space>
                    </Card>
                </div>
            );
        }

        return this.props.children;
    }
}

export default MobileErrorBoundary;

